<template>
  <div class="Fankui">
    <div class="container">
      <van-tabs border
                animated
                title-active-color="#263e65">
        <van-tab :title="item.title"
                 v-for="(item,index) in lists"
                 :key="index">
          <div class="jiaocai-card">
            <van-row gutter="10">
              <van-col span="12"
                       v-for="(item2,index2) in item.lists"
                       :key="index2">
                <div class="lis">
                  <div class="imgbox">
                    <img :src="item2.img"
                         alt="">
                  </div>
                  <h3> {{item2.name}} </h3>
                  <p>
                    <span class="tit">
                      定价：
                    </span>
                    <span class="desc">
                      {{item2.price}}
                    </span>
                  </p>
                  <p>
                    <span class="tit">
                      作者：
                    </span>
                    <span class="desc">
                      {{item2.author}}
                    </span>
                  </p>
                  <p>
                    <span class="tit">
                      出版社：
                    </span>
                    <span class="desc">
                      {{item2.press}}
                    </span>
                  </p>
                  <p>
                    <span class="tit">
                      ISBN：
                    </span>
                    <span class="desc">
                      {{item2.ISNB}}
                    </span>
                  </p>

                </div>
              </van-col>
            </van-row>
          </div>
        </van-tab>
      </van-tabs>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import axiosApi from "../api/api.js";

export default {
  name: 'Jiaocai',
  components: {
  },
  data () {
    return {
      lists: [{
        title: '商务汉语',
        lists: [{
          img: require('@/assets/book1.jpg'),
          name: '《BCT标准教程1》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107296857'
        }, {
          img: require('@/assets/book2.jpg'),
          name: '《BCT标准教程2》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107244292'
        }, {
          img: require('@/assets/book3.jpg'),
          name: '《BCT标准教程3》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107307928'
        }, {
          img: require('@/assets/book4.jpg'),
          name: '《BCT大纲A》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '高等教育出版社',
          ISNB: '9787040343908'
        }, {
          img: require('@/assets/book5.jpg'),
          name: '《BCT大纲b》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '高等教育出版社',
          ISNB: '9787040411843'
        }, {
          img: require('@/assets/book6.jpg'),
          name: '《商务汉语能力标准》',
          price: '￥79',
          author: '孔子学院总部/国家汉办',
          press: '高等教育出版社',
          ISNB: '9787040389531'
        }, {
          img: require('@/assets/book7.jpg'),
          name: '《商务汉语考试真题集A》',
          price: '￥89',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107329685'
        }, {
          img: require('@/assets/book8.jpg'),
          name: '《商务汉语考试真题集B》',
          price: '￥89',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107329678'
        }]
      },
      {
        title: '汉语水平标准课程',
        lists: [{
          img: require('@/assets/book9.jpg'),
          name: '《HSK标准教程1》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107296857'
        }, {
          img: require('@/assets/book10.jpg'),
          name: '《HSK标准教程2》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107244292'
        }, {
          img: require('@/assets/book11.jpg'),
          name: '《HSK标准教程3》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107307928'
        }, {
          img: require('@/assets/book12.jpg'),
          name: '《HSK标准教程4A》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107307928'
        }, {
          img: require('@/assets/book13.jpg'),
          name: '《HSK标准教程4B》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107307928'
        }, {
          img: require('@/assets/book14.jpg'),
          name: '《HSK标准教程5A》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107307928'
        }, {
          img: require('@/assets/book15.jpg'),
          name: '《HSK标准教程5B》',
          price: '￥49',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107307928'
        }, {
          img: require('@/assets/book16.jpg'),
          name: '《HSK考试大纲1》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107304187'
        }, {
          img: require('@/assets/book17.jpg'),
          name: '《HSK考试大纲2》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107304194'
        }, {
          img: require('@/assets/book18.jpg'),
          name: '《HSK考试大纲3》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107304200'
        }, {
          img: require('@/assets/book19.jpg'),
          name: '《HSK考试大纲4》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107304217'
        }, {
          img: require('@/assets/book20.jpg'),
          name: '《HSK考试大纲5》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107304224'
        }, {
          img: require('@/assets/book21.jpg'),
          name: '《HSK考试大纲6》',
          price: '￥69',
          author: '孔子学院总部/国家汉办',
          press: '人民教育出版社',
          ISNB: '9787107304873'
        }]
      }]
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.Fankui {
  height: 100% !important;
}
.container {
  padding: 0;
}
.jiaocai-card {
  padding: 20px;
  .lis {
    width: 345px;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    .imgbox {
      img {
        height: 400px;
      }
    }
  }
}
</style>
